// 获取全局引用，在浏览器端是window
export const getGlobalData = (): Record<string, any> => {
  if (typeof process !== 'undefined') {
    return global;
  }
  return window;
};

// 设置全局数据
export const setGlobalData = (key: string, value: any) => {
  const w = getGlobalData();
  w[key] = value;
  return w;
};
